import Navbar from "@/components/site/Navbar";
import SeasonalServices from "@/components/site/SeasonalServices";
import RedDoorStrip from "@/components/site/RedDoorStrip";
import CareGuideBanner from "@/components/site/CareGuideBanner";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import FountainBuilds from "@/components/site/FountainBuilds";
import Faq from "@/components/site/Faq";
import Reviews from "@/components/site/Reviews";
import AvailablePieces from "@/components/site/AvailablePieces";
import GfysNews from "@/components/site/GfysNews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import BackToTop from "@/components/site/BackToTop";
import SeoHead from "@/components/site/SeoHead";
import BestSellingBirdBaths from "@/components/site/BestSellingBirdBaths";
import SignatureMajestic from "@/components/site/SignatureMajestic";
import StickyMobileBar from "@/components/site/StickyMobileBar";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#F9F6F0] text-[#2C2A28] pb-14 md:pb-0">
      <SeoHead />
      <Navbar />
      <main>
        <Hero />
        <SeasonalServices />
        <CareGuideBanner />
        <RedDoorStrip />
        <About />
        <SignatureMajestic />
        <GfysNews />
        <BestSellingBirdBaths />
        <AvailablePieces />
        <FountainBuilds />
        <Faq />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
      <StickyMobileBar />
    </div>
  );
}
